/**
 * Created by eliranm on 05/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var BaseModel = require('models/BaseModel');
    var Config = require('content-config/contentImportConfig.json');

    var ContentImportLayoutModel = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportLayoutModel = BaseModel.extend({
            name: "ContentImportLayoutModel",
            defaults: {
                header: {
                    title: LE.translator.translate(Config.i18n.header.title),
                    description: LE.translator.translate(Config.i18n.header.description),
                    knowledgePack: {
                        text: LE.translator.translate(Config.i18n.header.kpCaption),
                        eventId: Config.KnowledgePack.kpId
                    }
                },
                importButtonDisabledTooltip: LE.translator.translate(Config.i18n.importButtonDisabledTooltip)
            },

            getHeader: function () {
                return this.get(ContentImportLayoutModel.KEYS.header);
            },

            getImportButtonDisabledTooltip: function () {
                return this.get(ContentImportLayoutModel.KEYS.importButtonDisabledTooltip);
            }
        });

        ContentImportLayoutModel.KEYS = {
            header: 'header',
            importButtonDisabledTooltip: 'importButtonDisabledTooltip'
        };
    });

    return ContentImportLayoutModel;
});
